import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import RenderCommission from '../../cmp/RenderCommission';

class MLMCommissionsTable extends Component {
    render() {
        const {standard, special} = this.props;
        if(!standard || standard.length === 0) return null;
        return (
            <table className="table table-striped table-sm">
                <thead>
                <tr>
                    <th><FormattedMessage id={"Level"}/></th>
                    <th><FormattedMessage id={"Commission"}/></th>
                </tr>
                </thead>
                <tbody>
                {
                    standard
                        .filter(({commission_value}) => Number(commission_value))
                        .map(({commission_value, commission_type, level}, index) => (<tr key={String(index)}>
                            <td><FormattedMessage id={`Level ${level}`}/></td>
                            <td><RenderCommission commission_value={commission_value} commission_type={commission_type}/></td>
                        </tr>))
                }
                </tbody>
            </table>
        );
    }
}

function mapStateToProps(state) {
    const {mlm} = state.commissions;
    return mlm || {}
}


export default connect(
    mapStateToProps
)(MLMCommissionsTable);
